import { apiRequest } from './client'

export type ObservanceKind = 'religious' | 'cultural'

export interface PeakPeriod {
  id: string
  name: string
  observance: string
  observanceKind: ObservanceKind
  startDate: string
  endDate: string
  teamIds: string[]
  active: boolean
  createdAt: string
  updatedAt: string
}

export interface PeakPeriodCreate {
  name: string
  observance: string
  observanceKind: ObservanceKind
  startDate: string
  endDate: string
  teamIds: string[]
  active: boolean
}

export type PeakPeriodUpdate = Partial<PeakPeriodCreate>

export type PeakPeriodActiveFilter = 'true' | 'false' | 'all'

export function listPeakPeriods(
  active: PeakPeriodActiveFilter = 'true',
): Promise<PeakPeriod[]> {
  return apiRequest<PeakPeriod[]>(
    `/api/v1/hr/peak-periods?active=${encodeURIComponent(active)}`,
  )
}

export function createPeakPeriod(input: PeakPeriodCreate): Promise<PeakPeriod> {
  return apiRequest<PeakPeriod>('/api/v1/hr/peak-periods', {
    method: 'POST',
    body: input,
  })
}

export function updatePeakPeriod(
  id: string,
  input: PeakPeriodUpdate,
): Promise<PeakPeriod> {
  return apiRequest<PeakPeriod>(
    `/api/v1/hr/peak-periods/${encodeURIComponent(id)}`,
    {
      method: 'PATCH',
      body: input,
    },
  )
}

/** Soft-delete — server flips `active=false` and returns the row. */
export function deactivatePeakPeriod(id: string): Promise<PeakPeriod> {
  return apiRequest<PeakPeriod>(
    `/api/v1/hr/peak-periods/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
  )
}
